export default "__VITE_ASSET__CeHI6x0W__"